import React from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroContent from './components/HeroContent';

function App() {
  return (
    <div>
      <Header />
      <HeroContent />
      <Footer />
    </div>
  );
}

export default App;
